module.exports = __webpack_public_path__ + "img/rugby.6bbaa6bb.png";